import { CustomUserActions } from '../actions';
import { CustomUserState } from '../user-state';

export const initialState: CustomUserState['legalEntityStatus'] = false;

export function legalEntityStatusReducer(
  state = initialState,
  action: CustomUserActions.SetLegalEntityStatus,
): CustomUserState['legalEntityStatus'] {
  switch (action.type) {
    case CustomUserActions.SET_LEGAL_ENTITY_STATUS: {
      return action.payload;
    }

    default: {
      return state;
    }
  }
}
